<template>
  <div class="projects-list-container">

    <div class="header-container">
      <div class="left">
        <div class="title">My Projects</div>
        <span class="subtitle">Current Projects ({{ projects.length }})</span>
      </div>
      <div class="right">
        <div class="search">
          <input type="text" class="input" v-model="filter" placeholder="Search your projects..." @keydown.esc="filter = ''"/>
          <i class="fa fa-search filter-icon"/>
        </div>
      </div>
    </div>


    <div class="projects" ref="projects">

      <div class="project-card-container add-project-card" @click="showAddProjectOverlay()">
        <div class="content">
          <div class="icon"><i class="fa fa-plus"/></div>
          <div>Add New Project</div>
        </div>
      </div>

      <div class="project-card-container" v-for="p in sortedFilteredProjects" :key="p.name">
        <project-card :project="p"/>
      </div>

      <div class="project-card-dummy" v-for="i in dummyCards" :key="i"></div>

      <transition name="fade">
        <div v-if="loadingProjects" class="row" style="text-align:center;">
          <img src="../../assets/spinner.svg" alt="loading" style="margin:auto;">
        </div>
      </transition>
    </div>

    <div v-if="showAddProject" class="modal-overlay">
      <div class="modal-content add-project">
        <div class="close-icon" @click="showAddProject = false">
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 16 16" style="transform:rotate(45deg);position:relative;top:4px;"><g fill="none"><g style="stroke-width:3;stroke:#F7103C"><path d="M8 8L8-1 8 8 -1 8 8 8ZM8 8L17 8 8 8 8 17 8 8Z"/></g></g></svg>
        </div>
        <div class="header">Add New Project</div>
        <div class="name">
          <input type="text" class="input" v-model="newProjectName" placeholder="New Project Name" maxlength="50">
          <div class="valid-chars" :class="{'red' : !projectNameValid}">Please use only letters and numbers.</div>
          <div class="project-url">Project URL:<br/>https://app.simplystudio.com/{{user.email}}/{{ newProjectName | URLify }}</div>
        </div>
        <div class="save-button" :class="{ 'inactive': !projectNameValid }" @click="addProject()">
          <span v-if="creatingProject"><i class="fa fa-spin fa-circle-notch"/></span>
          <span v-else>Save</span>
        </div>
      </div>
    </div>

    <div v-if="showLimitReached" class="modal-overlay">
      <div class="modal-content limit-reached">
        <div class="close-icon" @click="showLimitReached = false">
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 16 16" style="transform:rotate(45deg);position:relative;top:4px;"><g fill="none"><g style="stroke-width:3;stroke:#F7103C"><path d="M8 8L8-1 8 8 -1 8 8 8ZM8 8L17 8 8 8 8 17 8 8Z"/></g></g></svg>
        </div>
        <div class="header">Account Limit Reached</div>
        <div class="limit-reached-content">
          Wow that was fast!  You have reached your limit of projects.  
          <p>Upgrade now for access to unlimited projects and galleries, premium support, and exclusive discounts.</p>
        </div>
        <div class="button" @click="$router.push('/subscription')">Upgrade now</div>
      </div>
    </div>
  </div>
</template>

<script>
import projectService from '@/services/project-service.js'

import ProjectCard from '@/components/projects/ProjectCard.vue'

export default {
  name: 'ProjectList',
  components: {
    ProjectCard,
  },
  data() {
    return {
      filter: '',

      showAddProject: false,
      newProjectName: '',
      creatingProject: false,

      showLimitReached: false,

      sortBy: 'created',
      sortReversed: false,

      cardsPerRow: 0,
    }
  },
  created() {
    this.$store.dispatch('getProjects')
  },
  mounted() {
    let containerWidth = this.$refs.projects.getBoundingClientRect().width
    this.cardsPerRow = Math.floor(containerWidth/300)
    // TODO: resize handler
  },
  methods: {
    triggerAddNew() {
      if(this.addNew) {
        this.addNew = !this.addNew
        return
      }
      this.addNew = true
      this.$nextTick(() => this.$refs.projectname.focus())
    },
    async addProject() {
      if(this.projectNameValid && !this.creatingProject) {
        this.creatingProject = true
        await projectService.createProject(this.newProjectName.trim())
        this.creatingProject = false
        this.showAddProject = false
        this.newProjectName = ''
        this.$store.dispatch('getProjects')
      }
    },
    sort(s) {
      if(this.sortBy == s) {
        this.sortReversed = !this.sortReversed
        return
      }
      this.sortBy = s
      this.sortReversed = false
    },
    showAddProjectOverlay() {
      if(this.projects.length >= this.projectLimit) {
        this.showLimitReached = true
        return
      }
      this.showAddProject = true
    }
  },
  computed: {
    projectNameValid() {
      const validExpression = /^[a-z0-9\s]+$/i
      return this.newProjectName.length > 0 && validExpression.test(this.newProjectName)
    },
    loadingProjects() {
      return this.$store.getters.loadingProjects
    },
    projects() {
      return this.$store.getters.projects
    },
    dummyCards() {
      if(this.sortedFilteredProjects.length > 0 && this.cardsPerRow != 0)
        return this.cardsPerRow - (this.sortedFilteredProjects.length % this.cardsPerRow) - 1
      return 0
    },
    filteredProjects () {
      if(this.filter == "")
        return this.projects
      return this.projects.filter(p => {
        const f = this.filter.toLowerCase()
        return p.name.toLowerCase().includes(f)
      })
    },
    sortedFilteredProjects() {
      let sorted = this.filteredProjects.slice().sort((a, b) => {
        return a[this.sortBy] - b[this.sortBy]
      })
      if(this.sortReversed) {
        sorted = sorted.reverse()
      }
      return sorted
    },
    user() {
      return this.$store.getters.user
    },
    subscription() {
      return this.$store.getters.subscription
    },
    isTrial() {
      return this.$store.getters.isTrial
    },
    projectLimit() {
      if(this.isTrial) {
        return 2
      }
      if(this.subscription.type == 'hobbyist') {
        return 5
      }
      return 100
    }
  },
  watch: {
    projects() {
      if(this.projects.length == 0) {
        this.addNew = true
      } else {
        this.addNew = false
        
        if(this.$intercom) {
          this.$intercom.update({
            "nr_of_projects": this.projects.length
          })
        }
      }
    }
  },
  filters: {
    URLify(s) {
      if(s) {
        s = s.trim()
        const regex = /[^a-z0-9]/gi
        return s.replace(regex, '_')
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/shared.scss';

.projects-list-container {
  padding: 0px 100px;
}

.header-container {
  display: flex;
  padding: 50px 0px;

  div {
    flex: 1;
  }

  .left {
    text-align: left;

    .title {
      font-size: 24px;
      font-weight: 700;
      padding: 10px 0px;
    }

    .subtitle {
      color: $secondaryText;
    }
  }

  .right {
    position: relative;

    .search {
      width: 300px;
      max-width: 300px;
      position: absolute;
      right: 0;

      input {
        padding-left: 40px;
        border-radius: 25px;
      }

      .filter-icon {
        position: absolute;
        top: 15px;
        left: 15px;
        font-size: 20px;
        color: $primaryText;
        opacity: 0.7;
      }
    }
  }
}


.projects {
  display: flex;
  flex-wrap: wrap;

  .project-card-container {
    flex: 1;
    min-width: 300px;
    margin: 10px;
    transition: 0.1s all;
  }

  .project-card-dummy {
    flex: 1;
    min-width: 300px;
    margin: 10px; 
  }

  .add-project-card {
    border: 2px dashed $separator;
    position: relative;
    max-width: 500px;
    min-height: 300px;
    
    .content {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      text-align: center;
      cursor: pointer;

      .icon {
        width: 60px;
        height: 60px;
        line-height: 60px;
        text-align: center;
        color: $primary;
        background-color: rgb(247, 249, 251);
        border-radius: 50%;
        margin: auto;
        font-size: 20px;
        margin-bottom: 20px;
        transition: all 0.2s;
      }

      &:hover {
        .icon {
          box-shadow: 2px 2px 10px rgba(black, 0.2);
        }
      }
    }
  }
}

.add-project, .limit-reached {
  padding: 50px;
  text-align: left;
  width: 500px;
  border-radius: $border-radius;
  position: relative;
  background-color: white;

  .header {
    margin-bottom: 20px;
    font-size: 20px;
  }

  .name {
    input {
      border-radius: $border-radius;
    }

    .valid-chars {
      margin: 10px 0px;
    }

    .project-url {
      color: $secondaryText;
      // max-width: 100%;
      word-wrap: break-word;
    }
  }

  .save-button, .button {
    margin-top: 50px;
    padding: 20px 30px;
    background-color: $primary;
    border-radius: $border-radius;
    color: white;
    text-align: center;
    font-weight: 500;
    cursor: pointer;

    &:hover {
      box-shadow: 2px 2px 10px rgba(black, 0.4);
    }
  }
  .inactive {
    background-color: rgb(232, 232, 232);
    cursor: not-allowed;
    &:hover {
      box-shadow: none;
    }
  }

  .close-icon {
    position: absolute;
    top: -16px;
    right: -16px;
    width: 40px;
    height: 40px;
    line-height: 40px;
    border-radius: 50%;
    background-color: white;
    box-shadow: 2px 2px 10px rgba(black, 0.4);
    text-align: center;
    cursor: pointer;
  }
}

</style>